<template>
        <TextCard class="container">
            <div slot="textCard__Text" class="content-wrapper">
                <v-row no-gutters class="equal-height-row">
                    <v-col cols="5" class="left-section equal-height">
                        <slot name="left"></slot>
                    </v-col>
                    <v-col cols="7" class="right-section equal-height">
                        <slot name="right"></slot>
                    </v-col>
                </v-row>
            </div>        
        </TextCard>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "Card Title",
        },
        icon: {
            type: String,
            default: "mdi-card",
        },
    },
};
</script>

<style scoped>
/* Center the card and ensure it takes 80% of the viewport width */
.container {
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    /*height: 100vh; /* Centers vertically */
}

/* Make the card take full available space */
.md-card {
    width: 90%;
    display: flex;
    flex-direction: column;
    height: 100%;
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

/* Make the card content stretch */
.content-wrapper {
    display: flex;
    flex-grow: 1;
    height: 100%;
}

/* Make the row stretch across the card */
.equal-height-row {
    display: flex;
    align-items: stretch;
    flex-wrap: nowrap;
    flex-grow: 1;
}

/* Make both columns stretch fully */
.equal-height {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/company/kirc/components/SummaryCard.vue